var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8SignerUnDocument2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,256l0,-67.92455c1.23441,3.40214 3.44657,6.45954 6.49586,8.73043l17.30553,12.88324l-6.42715,20.59148c-1.81668,5.81917 -0.80339,11.94957 2.78654,16.82783c3.57546,4.86379 9.29331,7.76613 15.30066,7.76613c3.92288,0 7.70099,-1.21595 10.93628,-3.51032l17.60227,-12.47069l17.60227,12.47793c3.23529,2.29438 7.02064,3.51032 10.93628,3.51032c6.00736,0 11.7252,-2.90235 15.30066,-7.76613c3.58994,-4.87826 4.60323,-11.0159 2.78654,-16.82783l-6.42715,-20.59148l17.30553,-12.88324c6.52124,-4.85655 9.21369,-13.31751 6.70218,-21.04746c-2.51151,-7.72995 -9.66243,-12.99181 -17.79046,-13.0859l-21.57581,-0.24608l-6.90484,-20.43948c-2.59836,-7.70099 -9.80719,-12.87601 -17.93521,-12.87601c-8.12802,0 -15.33685,5.17501 -17.94245,12.87601l-6.8976,20.43948l-21.57581,0.24608c-7.91563,0.09163 -14.90456,5.08449 -17.58414,12.48504v-175.1648h256v256z",
    id: "overlayBgMask",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)",
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,4c-2.48,0 -4.5,2.02 -4.5,4.5v31c0,2.48 2.02,4.5 4.5,4.5h23c2.48,0 4.5,-2.02 4.5,-4.5v-10.31055l-3,3v7.31055c0,0.83 -0.67,1.5 -1.5,1.5h-23c-0.83,0 -1.5,-0.67 -1.5,-1.5v-31c0,-0.83 0.67,-1.5 1.5,-1.5h11.5v8.5c0,2.48 2.02,4.5 4.5,4.5h2.31055l3,-3h-5.31055c-0.83,0 -1.5,-0.67 -1.5,-1.5v-6.37891l7.34961,7.34961l1.4707,-1.48047c0.22,-0.22 0.44945,-0.41961 0.68945,-0.59961l-9.94922,-9.95117c-0.27,-0.27 -0.64055,-0.43945 -1.06055,-0.43945zM43.96094,13.98047c-0.5196,0.01548 -1.01276,0.23264 -1.375,0.60547l-0.66211,0.66211c-0.63096,-0.20762 -1.28802,-0.2819 -1.93164,-0.20117c-1.02277,0.12829 -2.0021,0.59976 -2.75391,1.35156c-0.00065,0 -0.0013,0 -0.00195,0l-9.56641,9.56836c-0.40395,0.40395 -0.7031,0.89932 -0.87109,1.44531c0,0.00065 0,0.0013 0,0.00195l-1.73242,5.64648c-0.16207,0.53041 -0.01827,1.10697 0.3739,1.49914c0.39218,0.39218 0.96873,0.53598 1.49914,0.3739l5.64648,-1.73242c0.00065,0 0.0013,0 0.00195,0c0.54599,-0.168 1.04136,-0.46714 1.44531,-0.87109l9.64844,-9.64844c1.23367,-1.23272 1.57454,-3.03576 1.06445,-4.59961l0.66797,-0.66797c0.59152,-0.57498 0.76938,-1.45413 0.44787,-2.21382c-0.32151,-0.75969 -1.07643,-1.24408 -1.90099,-1.21977zM40.33398,18.03125c0.35123,-0.04871 0.70323,0.01859 0.98438,0.20898c0.08922,0.06042 0.16444,0.128 0.23633,0.19727c0.02164,0.02199 0.04378,0.04348 0.06641,0.06445c0.56547,0.60822 0.5179,1.48059 -0.06055,2.05859l-9.64844,9.64844c-0.05805,0.05805 -0.12903,0.101 -0.20703,0.125l-2.94141,0.90234l0.90234,-2.94141c0.024,-0.07801 0.06695,-0.14898 0.125,-0.20703l9.56836,-9.56836c0.2742,-0.2742 0.62338,-0.43957 0.97461,-0.48828zM17.5,25c-0.83,0 -1.5,0.67 -1.5,1.5c0,0.83 0.67,1.5 1.5,1.5h7.0293l0.36133,-1.16992c0.2,-0.67 0.52875,-1.29008 0.96875,-1.83008zM17.5,32c-0.83,0 -1.5,0.67 -1.5,1.5c0,0.83 0.67,1.5 1.5,1.5h5.83984c-0.37,-0.78 -0.44945,-1.6793 -0.18945,-2.5293l0.15039,-0.4707z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.3363,143.59392) scale(7.23778,7.23778)",
    id: "overlay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.751,5.748l-3.529,2.627l1.311,4.199c0.176,0.563 -0.463,1.027 -0.945,0.686l-3.588,-2.545l-3.588,2.544c-0.481,0.341 -1.12,-0.123 -0.945,-0.686l1.311,-4.199l-3.529,-2.626c-0.473,-0.352 -0.229,-1.103 0.361,-1.11l4.399,-0.051l1.408,-4.168c0.189,-0.559 0.979,-0.559 1.167,0l1.408,4.168l4.399,0.051c0.588,0.006 0.833,0.758 0.36,1.11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SignerUnDocument2);
export default __webpack_public_path__ + "static/media/icons8-signer-un-document (2).c7703423b2f856b04ef62c5517fea3f8.svg";
export { ForwardRef as ReactComponent };